module.exports = __webpack_public_path__ + "static/media/beecloud.f6676cbf.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/beecloud.ico
// module id = 74
// module chunks = 0